<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  props: {},
  beforeCreate() {
    // 登录成功
    this.$authServices.getAuthState().then((res) => {
      if (res) {
        let str = "";
        str += this.$route.query.sso;
        for (const key in this.$route.query) {
          if (key !== "sso") {
            str += "&" + key + "=" + this.$route.query[key];
          }
        }
        location.href = str;
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "未登录！",
          onOk: () => {
            location.href = "http://gxyj.yzl.ltd?type=1";
          },
        });
      }
    });
  },
};
</script>
<style scoped></style>
